// The billing module's entire public surface.
//
// Two exports and one stylesheet, following the dashboard and engagement
// modules' boundary: nothing outside this folder imports from any other file in
// it, and nothing in here imports from `pages/`. Deleting the module is
// deleting the folder and three lines in App.tsx.
//
// It does import from `lib/` — `WorkspaceContext`, `entitlements` for the
// formatters, `supabase`, `logger` — which is the same allowance every module
// has. `lib/` is the shared floor; `pages/` is a sibling.

import "./billing.css";

export { Billing } from "./Billing";
export type { WorkspaceUsage } from "./types";

/** Where the nav link points. Kept here so callers never hardcode it. */
export const BILLING_ROUTE = "/billing";

/**
 * The permission this screen needs, exported so App.tsx can hide the nav link
 * without knowing why.
 *
 * It is the permission the catalogue already defines as "See the plan, usage
 * and billing history" (migration 20260823000400), and by the role matrix it is
 * held by **owner, admin and manager**. Hiding the link is a courtesy; the gate
 * is `has_workspace_permission()` inside `workspace_usage()`.
 */
export const BILLING_PERMISSION = "billing.view";
